// extracted by mini-css-extract-plugin
export default {"bottomWrapper":"MailboxExchangeSynchronization_bottomWrapper__7cmgi","alert":"MailboxExchangeSynchronization_alert__51gmX"};